import React from 'react';
import { Zap, Check, Clock } from 'lucide-react';

const automations = [
  { label: 'New lead → your CRM', sub: 'Lead-Intake Autopilot' },
  { label: 'Invoice → bookkeeping', sub: 'Paperwork Killer' },
  { label: 'Inbox sorted & drafted', sub: 'Inbox Triage' }
];

// Decorative illustration of automations running — stands in for "what we do".
const HeroVisual = () => (
  <div className="relative w-full max-w-md mx-auto" aria-hidden="true">
    <div className="absolute top-0 right-0 sm:-top-5 sm:-right-5 w-24 h-24 rounded-full bg-brand-green/10"></div>
    <div className="absolute bottom-0 left-0 sm:-bottom-6 sm:-left-6 w-20 h-20 rounded-full bg-pink-500/10"></div>

    <div className="relative bg-white rounded-2xl shadow-xl ring-1 ring-gray-100 p-6">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-brand-green flex items-center justify-center">
            <Zap className="w-4 h-4 text-white" />
          </div>
          <span className="font-display font-semibold text-gray-900">Your automations</span>
        </div>
        <span className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-green">
          <span className="w-2 h-2 rounded-full bg-brand-green"></span>
          Live
        </span>
      </div>

      <div className="space-y-3">
        {automations.map((item, index) => (
          <div key={index} className="flex items-center gap-3 rounded-xl bg-gray-50 px-4 py-3">
            <div className="w-7 h-7 rounded-full bg-brand-green/10 flex items-center justify-center shrink-0">
              <Check className="w-4 h-4 text-brand-green" />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">{item.label}</p>
              <p className="text-xs text-gray-500 truncate">{item.sub}</p>
            </div>
            <span className="ml-auto text-xs font-medium text-gray-400 shrink-0">handled</span>
          </div>
        ))}
      </div>

      <div className="mt-5 pt-4 border-t border-gray-100 flex items-center gap-2 text-sm text-gray-600">
        <Clock className="w-4 h-4 text-brand-green shrink-0" />
        <span>Your team&rsquo;s time, handed back.</span>
      </div>
    </div>
  </div>
);

export default HeroVisual;
